import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Button,
  Box,
  Modal,
  Typography,
  IconButton,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { setScreenuser } from "../redux/slices/screenusersSlice";
import { makeStyles } from "@material-ui/core/styles";
 
import { setTruInkAllSites } from "../redux/slices/truInk";
import callPiggybackAPI from "./TruInk/Helpers/piggyback.api.helper";

import MeetingRoomTable from "./MeetingRoomTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/EditNote";
import Divider from "@mui/material/Divider";
import { toast } from "react-toastify";
import { addOption } from "../redux/slices/capabilitiesSlice";
import { setResolutionsList } from "../redux/slices/resolutionSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "35ch",
      borderRadius: "10px",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "10px",
  },
  button: {
    backgroundColor: "#2771EB",
  },
  label: {
    fontWeight: "bold",
  },
  firstModalContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  fieldContainer: {
    display: "flex",
    alignItems: "center",
  },
  test: {
    display: "flex",
    flexDirection: "column",
  },
  divider: {
    margin: "20px 0",
  },
}));

const MyScreenuserForm = ({ selectedOption }) => {
  const [screenUserName, setName] = useState("");
  const [customizationId, setCustomizationId] = useState("");
  const [screenType, setScreenType] = useState("");
  const [locationId, setLocationId] = useState(null);
  const [neighboringId, setNeighboringId] = useState([]);
  const [meetingSpaceId, setMeetingSpaceId] = useState(null);
  const [open, setOpen] = useState(false);
  const headers = useSelector((state) => state.header);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const api = localStorage.getItem("api");
  const curremms = useSelector((state) => state.curremms);

  const [error, setError] = useState(false);
  const oldScreenUsers = useSelector((state) => state.screenusers);
  const [isBanquet, setIsBanquet] = useState(false);
  const [isKiosk, setIsKiosk] = useState(false);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [meetingRooms, setMeetingRooms] = useState([]);

  const [orientationOptions, setOrientationOptions] = useState({});
  const [shortNavigationOptions, setShortNavigationOptions] = useState({});
  const [isNextClicked, setIsNextClicked] = useState(false);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const [loading, setLoading] = useState(true);
  const [totalMRCount, setTotalMRCount] = useState(0);
  const [screenOrientation, setScreenOrientation] = useState("");
  const [resolution, setResolution] = useState("");
  const [kioskTemplateId, setKioskTemplateId] = useState("");
  const [kioskTemplates, setKioskTemplates] = useState([]);
  const [customProperties, setCustomProperties] = useState({});
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const tabs = useSelector(
    (state) => state?.user?.user?.customProperties?.tabs || []
  );
  const truInkSites = useSelector((state) => state?.truInk?.allSites || []);
  const [linkTruInk, setLinkTruInk] = useState(false);
  const [truInkTagMacAddress, setTruInkTagMacAddress] = useState("");
  const [truInkSiteId, setTruInkSiteId] = useState("");
  const [truInkTags, setTruInkTags] = useState([]);
  const [truInkTagsLoading, setTruInkTagsLoading] = useState(false);

  useEffect(() => {
    if (tabs.includes("truink") && truInkSites.length === 0) {
      callPiggybackAPI("site", {}, {}, "GET").then((response) => {
        if (response) {
          dispatch(setTruInkAllSites(response));
        }
      });
    }
  }, []);

  // Tag Mac Address is a dropdown of the digital tags belonging to the
  // selected TruInk Site, so it needs that site's tags fetched first.
  useEffect(() => {
    if (!tabs.includes("truink") || !linkTruInk || !truInkSiteId) {
      setTruInkTags([]);
      return;
    }
    const site = truInkSites.find((s) => (s.id ?? s._id) === truInkSiteId);
    if (!site) return;

    setTruInkTagsLoading(true);
    callPiggybackAPI(
      "digitalTag",
      { siteId: truInkSiteId, tenantId: site.tenantId },
      {},
      "GET"
    )
      .then((response) => setTruInkTags(Array.isArray(response) ? response : []))
      .catch(() => setTruInkTags([]))
      .finally(() => setTruInkTagsLoading(false));
  }, [linkTruInk, truInkSiteId, truInkSites, tabs]);

  const resetTruInkLink = () => {
    setLinkTruInk(false);
    setTruInkTagMacAddress("");
    setTruInkSiteId("");
    setTruInkTags([]);
  };

  // Get resolutions from Redux
  const resolutionsList = useSelector((state) => state?.resolution?.resolutions);

  const handleScreenOrientation = async (event) => {
    setScreenOrientation(event.target.value);
  };
  const handleResolution = async (event) => {
    setResolution(event.target.value);
  };

  useEffect(() => {
    if (screenType !== "Kiosk") return;
    const requestBody = {
      path: "kioskStudio",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };
    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((res) => setKioskTemplates(Array.isArray(res.data) ? res.data : []))
      .catch(console.error);
  }, [screenType]);

  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const newShowAdvanced = !prev;
      if (!newShowAdvanced) {
        setEditMode(false);
      }
      return newShowAdvanced;
    });
  };

  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };

  const handleCustomPropertyChange = (event) => {
    const { name, value } = event.target;

    setCustomProperties((prevProperties) => ({
      ...prevProperties,
      [name]: value,
    }));
  };

  const handleAddCustomProperty = () => {
    if (newKey && newValue) {
      setCustomProperties((prevProperties) => ({
        ...prevProperties,
        [newKey]: newValue,
      }));
      setNewKey("");
      setNewValue("");
    }
  };

  const handleNext = async () => {
    setIsNextClicked(true);
    setLoading(true);
    try {
      let allLocationIds = neighboringId ? neighboringId : "";
      if (meetingSpaceId) {
        const meetingRoom = meetingOptions?.allmeetingspaces?.find(
          (room) => room.id === meetingSpaceId
        );

        if (meetingRoom) {
          if (allLocationIds.length != 0) {
            allLocationIds += `,${meetingRoom.locationId}`;
          } else {
            allLocationIds = `${meetingRoom.locationId}`;
          }
        }
      }

      if (locationId) {
        if (allLocationIds.length != 0) {
          allLocationIds += `,${locationId}`;
        } else {
          allLocationIds = `${locationId}`;
        }
      }
      const requestBody = {
        path: "meetingspace/getbylocationId",
        query: {
          locationId: allLocationIds,
        },
        emmsId: `${selectedOption}`,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      const response = await axios.post(
        api + `/emms/piggyback`,
        requestBody,
        headers
      );

      setMeetingRooms(response.data);
      setTotalMRCount(response?.data?.length);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching meeting rooms:", error);
    }
  };
  const handleOrientationChange = (roomId, orientation) => {
    setOrientationOptions((prevOptions) => ({
      ...prevOptions,
      [roomId]: orientation,
    }));
  };
  const handleShortNavigationChange = (roomId, shortNavigationValue) => {
    setShortNavigationOptions((prevOptions) => ({
      ...prevOptions,
      [roomId]: shortNavigationValue,
    }));

    setMeetingRooms((prevRooms) =>
      prevRooms.map((room) => {
        if (room.id === roomId) {
          return { ...room, shortNavigation: shortNavigationValue };
        }
        return room;
      })
    );
  };
  const prepareMeetingSpaceDirections = (
    shortNavigationOptions,
    orientationOptions
  ) => {
    const meetingSpaceDirections = {};

    meetingRooms?.forEach((room) => {
      const roomId = room.id;
      const direction = orientationOptions[roomId];
      const shortNavigation = shortNavigationOptions[roomId];
      if (direction !== undefined || shortNavigation !== undefined) {
        meetingSpaceDirections[roomId] = { direction, shortNavigation };
      }
    });

    return meetingSpaceDirections;
  };



  const meetingOptions = useSelector((state) => state.allmeetingspaces);

  const locationOptions = useSelector((state) => state.location);

  const [neighbourOptions, setNeighbourOptions] = useState(
    locationOptions.location
  );

  const customisations = useSelector((state) => state.customisations);

  const handleTypeChange = (event) => {
    const selectedType = event.target.value;
    setScreenType(selectedType);

    setLocationId("");
    setNeighboringId([]);
    setMeetingSpaceId("");
    setKioskTemplateId("");
  };

  const handleLocationIdChange = (event) => {
    const locationId = event.target.value;

    const newArray = locationOptions?.location?.filter(
      (row) => row.id !== event.target.value
    );
    setNeighbourOptions(newArray);

    setLocationId(locationId);
  };

  const handleNeighboringIdChange = (event) => {
    const neighboringId = event.target.value;
    setNeighboringId(neighboringId);
  };

  const handleMeetingSpaceIdChange = (event) => {
    const meetingSpaceId = event.target.value;
    setMeetingSpaceId(meetingSpaceId);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsNextClicked(false);
    setLoading(false);
    setScreenOrientation("");
    setResolution("");
    setKioskTemplateId("");
    setCustomProperties({});
    setShowAdvanced(false);
    setEditMode(false);
    setNewKey("");
    setNewValue("");
    resetTruInkLink();
  };
  const handleCustomizationChange = (selectedOptions) => {
    setLoading(false);
    setCustomizationId(selectedOptions);

    const selectedCustomisation = customisations?.customisations?.find(
      (option) => option.id === selectedOptions
    );

    if (selectedCustomisation) {
      if (selectedCustomisation?.components?.includes("Banquet")) {
        setIsBanquet(true);
      } else {
        setIsBanquet(false);
      }

      if (selectedCustomisation?.components?.includes("Kiosk")) {
        setIsKiosk(true);
      } else {
        setIsKiosk(false);
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const json2 = {
      screenUserName: screenUserName,
      typeOfScreen: screenType,
      locationId: locationId,
      customisationId: customizationId,
      meetingRoomId: meetingSpaceId,
      neighbourId: neighboringId,
    };
    const meetingSpaceDirections = prepareMeetingSpaceDirections(
      shortNavigationOptions,
      orientationOptions
    );

    json2.customProperties = {
      ...customProperties,
      ...json2.customProperties,
      MeetingSpaceDirections: {
        ...meetingSpaceDirections,
      },
      totalMRCount,
      orientation: screenOrientation,
      resolution: resolution,
      ...(screenType === "Kiosk" && { kioskTemplateId }),
      ...(linkTruInk && {
        truInkAssociatedTagMacAddress: truInkTagMacAddress,
        truInkSiteId: truInkSiteId,
      }),
    };

    if (meetingSpaceId?.length === 0) {
      delete json2.meetingRoomId;
    }
    if (locationId?.length === 0) {
      delete json2.locationId;
    }

    setIsSubmitting(true);

    const requestBody = {
      path: "screenusers",
      query: {},
      emmsId: `${selectedOption}`,
      body: { ...json2 },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };
  
    if (
      screenUserName?.length == 0 ||
      screenType?.length == 0 ||
      customisations?.length == 0
    ) {
      setErrorModalOpen(true);
      setErrorMessage(`Please provide all the required fields `);
      setError(true);
      setName("");
      setCustomizationId("");
      setScreenType("");
      setLocationId("");
      setNeighboringId("");
      setMeetingSpaceId(null);
      setIsNextClicked(false);
      setOrientationOptions({});
      setShortNavigationOptions({});
      setScreenOrientation("");
      setResolution("");
      setKioskTemplateId("");
      setCustomProperties({});
      setShowAdvanced(false);
      setEditMode(false);
      resetTruInkLink();
    } else {
      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setIsSubmitting(false);
          setErrorModalOpen(true);
          const matchedCustomisation = customisations?.customisations?.find(c=>c.id==response?.data?.[0]?.customisationId)
          const matchedMeetingSpace = meetingOptions?.allmeetingspaces?.find(m=>m.id ===response?.data?.[0]?.meetingRoomId)
          const matchedLocation = locationOptions?.location?.find(l=>l.id===response?.data?.[0]?.locationId)

          const combinedData = [
            ...oldScreenUsers.screenusers,
            {...(response.data[0] || {}) ,
             customisation_name :matchedCustomisation?.name ,
             meeting_room_name:matchedMeetingSpace?.name,
             location_name: `${matchedLocation?.city || ""}${matchedLocation?.building ? `, ${matchedLocation.building}` : ""}${matchedLocation?.floor ? `, ${matchedLocation.floor}` : ""}`,
            },
          ];
          dispatch(setScreenuser(combinedData));
          setErrorMessage(`Screenuser added sucessfully`);
          setError(false);
          setName("");
          setCustomizationId("");
          setScreenType("");
          setLocationId("");
          setNeighboringId("");
          setMeetingSpaceId(null);
          setIsNextClicked(false);
          setOrientationOptions({});
          setShortNavigationOptions({});
          setScreenOrientation("");
          setResolution("");
          setKioskTemplateId("");
          setCustomProperties({});
          setShowAdvanced(false);
          setEditMode(false);
          resetTruInkLink();
        })
        .catch((error) => {
          setErrorModalOpen(true);
          setErrorMessage(`Error creating screenuser: ${error.response.data}`);
          setError(true);
          setName("");
          setCustomizationId("");
          setScreenType("");
          setLocationId("");
          setNeighboringId("");
          setMeetingSpaceId(null);
          setIsNextClicked(false);
          setOrientationOptions({});
          setShortNavigationOptions({});
          setScreenOrientation("");
          setResolution("");
          setKioskTemplateId("");
          setCustomProperties({});
          setShowAdvanced(false);
          setEditMode(false);
          resetTruInkLink();
        });
    }
  };

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
    setIsNextClicked(false);
    setOrientationOptions({});
    setShortNavigationOptions({});
    setScreenOrientation("");
    setResolution("");
    setKioskTemplateId("");
    setLoading(false);
    setCustomProperties({});
    setShowAdvanced(false);
    setEditMode(false);
    resetTruInkLink();
  };
  const handleBack = () => {
    setIsNextClicked(false);
  };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "120px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  // Add this to your existing useEffect or create a new one to fetch resolutions
  useEffect(() => {
    const fetchResolutions = async () => {
      const api = localStorage.getItem("api");

      const requestBody = {
        path: "resolution",
        query: {},
        emmsId: selectedOption,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.emmsheaders?.headers,
      };

      try {
        const response = await axios.post(api + `/emms/piggyback`, requestBody, headers);
        dispatch(setResolutionsList(response.data));
      } catch (error) {
        console.error("Error fetching resolutions:", error);
      }
    };

    fetchResolutions();
  }, [selectedOption, dispatch, emmsheaders, headers]);

  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Add Screenuser
      </Button>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            borderRadius: "10px",
            paddingTop: 1,
            paddingBottom: 4,
            paddingLeft: 4,
            paddingRight: 4,
            width:{xs:"95%",md:"unset"},
            maxWidth: {xs:"400px",md:"unset"},
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <form onSubmit={handleSubmit}>
            <div>
              <h2>Screenusers</h2>
              <h4 style={{ fontWeight: "100" }}>
                Add screenuser for {curremms?.curremms?.name}{" "}
              </h4>
            </div>

            {!isNextClicked && !showAdvanced && (
              <div className={classes.firstModalContent}>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Name:", true)}
                  <TextField
                    required
                    label="eg John Doe"
                    value={screenUserName}
                    onChange={(e) => setName(e.target.value)}
                    variant="outlined"
                    margin="normal"
                    size="small"
                  />
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Customisation:", true)}
                  <FormControl
                    style={{ width: "28.5ch" }}
                    variant="outlined"
                    margin="normal"
                    size="small"
                  >
                    <InputLabel required>Customization ID</InputLabel>
                    <Select
                      value={customizationId}
                      onChange={(e) =>
                        handleCustomizationChange(e.target.value)
                      }
                      label="Customization ID"
                    >
                      <MenuItem value="">
                        <em>-- Select --</em>
                      </MenuItem>
                      {customisations?.customisations?.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Type of Screen:", true)}
                  <FormControl
                    style={{ width: "28.5ch" }}
                    variant="outlined"
                    margin="normal"
                    size="small"
                  >
                    <InputLabel required>Manager or Navigator</InputLabel>
                    <Select
                      value={screenType}
                      onChange={handleTypeChange}
                      label="Type of Screen"
                    >
                      <MenuItem value="">
                        <em>-- Select --</em>
                      </MenuItem>
                      <MenuItem value="Manager">Manager</MenuItem>
                      <MenuItem value="Navigator">Navigator</MenuItem>
                      {isBanquet && (
                        <MenuItem value="Navigator Signage">
                          Navigator Signage
                        </MenuItem>
                      )}
                      {isBanquet && (
                        <MenuItem value="Manager Signage">
                          Manager Signage
                        </MenuItem>
                      )}
                      {isKiosk && (
                        <MenuItem value="Kiosk">Kiosk</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>

                {(screenType === "Manager" ||
                  screenType === "Manager Signage") && (
                  <div className={classes.test}>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Meeting Space ID:", true)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        margin="normal"
                        size="small"
                      >
                        <InputLabel required>Meeting Space ID</InputLabel>
                        <Select
                          value={meetingSpaceId}
                          onChange={handleMeetingSpaceIdChange}
                          label="Meeting Space ID"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>

                          {meetingOptions?.allmeetingspaces?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Neighbouring IDs:", false)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        margin="normal"
                        size="small"
                      >
                        <InputLabel required>Neighboring ID</InputLabel>
                        <Select
                          multiple
                          value={neighboringId}
                          onChange={handleNeighboringIdChange}
                          label="Neighboring ID"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>
                          {locationOptions?.location?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.floor} {option.city} {option.building}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                )}

                {(screenType === "Navigator" ||
                  screenType === "Navigator Signage") && (
                  <div className={classes.test}>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Location  ID:", true)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        margin="normal"
                        size="small"
                      >
                        <InputLabel required>Location ID</InputLabel>
                        <Select
                          value={locationId}
                          onChange={handleLocationIdChange}
                          label="Location ID"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>
                          {locationOptions?.location?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.floor} {option.city} {option.building}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Neighbouring IDs:", false)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        margin="normal"
                        size="small"
                      >
                        <InputLabel required>Neighboring ID</InputLabel>
                        <Select
                          multiple
                          value={neighboringId}
                          onChange={handleNeighboringIdChange}
                          label="Neighboring ID"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>
                          {neighbourOptions?.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              {option.floor} {option.city} {option.building}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                )}
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Orientation:", true)}
                  <TextField
                    style={{
                      width: "28.5ch",
                      height: "5ch",
                      marginTop: ".75rem",
                    }}
                    required
                    id="orientation"
                    name="orientation"
                    size="small"
                    label="Landscape or Portrait"
                    variant="outlined"
                    value={screenOrientation}
                    onChange={handleScreenOrientation}
                    select
                  >
                    <MenuItem value="landscape">Landscape</MenuItem>
                    <MenuItem value="portrait">Portrait</MenuItem>
                  </TextField>
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Resolution:", true)}
                  <Select
                    style={{
                      width: "28.5ch",
                      height: "5ch",
                      marginTop: ".75rem",
                    }}
                    required
                    id="resolution"
                    name="resolution"
                    size="small"
                    value={resolution}
                    onChange={handleResolution}
                    variant="outlined"
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select Resolution
                    </MenuItem>
                    {resolutionsList?.map((res) => (
                      <MenuItem key={res.id} value={res.value}>
                        {res.name} ({res.value})
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                {screenType === "Kiosk" && (
                  <div className={classes.fieldContainer}>
                    {getLabelWithAsterisk("Kiosk Template:", false)}
                    <FormControl
                      style={{ width: "28.5ch", height: "5ch" }}
                      variant="outlined"
                      size="small"
                      margin="normal"
                    >
                      <InputLabel>Kiosk Template</InputLabel>
                      <Select
                        value={kioskTemplateId}
                        onChange={(e) => setKioskTemplateId(e.target.value)}
                        label="Kiosk Template"
                      >
                        <MenuItem value="">
                          <em>-- Select --</em>
                        </MenuItem>
                        {kioskTemplates.map((t) => (
                          <MenuItem key={t.id} value={t.templateId}>
                            {t.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                )}

                {tabs.includes("truink") && (
                  <div className={classes.fieldContainer}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={linkTruInk}
                          onChange={(e) => setLinkTruInk(e.target.checked)}
                        />
                      }
                      label="Link TruInk"
                    />
                  </div>
                )}

                {tabs.includes("truink") && linkTruInk && (
                  <>
                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("TruInk Site:", true)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        size="small"
                        margin="normal"
                      >
                        <InputLabel required>TruInk Site</InputLabel>
                        <Select
                          value={truInkSiteId}
                          onChange={(e) => {
                            setTruInkSiteId(e.target.value);
                            setTruInkTagMacAddress("");
                          }}
                          label="TruInk Site"
                        >
                          <MenuItem value="">
                            <em>-- Select --</em>
                          </MenuItem>
                          {truInkSites?.map((site) => (
                            <MenuItem key={site.id} value={site.id}>
                              {site.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className={classes.fieldContainer}>
                      {getLabelWithAsterisk("Tag Mac Address:", true)}
                      <FormControl
                        style={{ width: "28.5ch", height: "5ch" }}
                        variant="outlined"
                        size="small"
                        margin="normal"
                        disabled={!truInkSiteId || truInkTagsLoading}
                      >
                        <InputLabel required>Tag Mac Address</InputLabel>
                        <Select
                          value={truInkTagMacAddress}
                          onChange={(e) => setTruInkTagMacAddress(e.target.value)}
                          label="Tag Mac Address"
                        >
                          <MenuItem value="">
                            <em>
                              {!truInkSiteId
                                ? "-- Select a site first --"
                                : truInkTagsLoading
                                ? "Loading tags…"
                                : "-- Select --"}
                            </em>
                          </MenuItem>
                          {truInkTags?.map((tag) => (
                            <MenuItem key={tag.id} value={tag.macAddress}>
                              {tag.name ? `${tag.name} (${tag.macAddress})` : tag.macAddress}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </>
                )}
              </div>
            )}

              {!isNextClicked && showAdvanced && (
                  <Box
                sx={{
                  display:"flex",
                  gap:2,
                  justifyContent:"space-between",
                  mt:2
                }}
                >
                  <Button
                    style={{ textTransform: "none" }}
                    variant="outlined"
                    color="primary"
                    onClick={toggleAdvanced}
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={toggleEditMode}
                    endIcon={!editMode ? <EditIcon /> : null}
                  >
                    {editMode ? "Save Changes" : "Edit JSON"}
                  </Button>
                </Box>
              )}


            {!isNextClicked && showAdvanced && editMode && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Edit Custom Properties</h6>
                <div style={{ marginBottom: "10px" }}>
                  {Object.keys(customProperties).map((key) => (
                    <div key={key} style={{ margin: "15px 0" }}>
                      <TextField
                        id={key}
                        name={key}
                        label={key}
                        variant="outlined"
                        size="small"
                        value={
                          typeof customProperties[key] === "object"
                            ? JSON.stringify(customProperties[key])
                            : customProperties[key]
                        }
                        onChange={handleCustomPropertyChange}
                      />
                    </div>
                  ))}
                </div>
                {Object.keys(customProperties).length > 0 && (
                  <div className={classes.divider}>
                    <Divider />
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <TextField
                    id="newKey"
                    name="newKey"
                    label="New Key"
                    variant="outlined"
                    size="small"
                    value={newKey}
                    onChange={(e) => setNewKey(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <TextField
                    id="newValue"
                    name="newValue"
                    label="New Value"
                    variant="outlined"
                    size="small"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomProperty}
                  >
                    Add
                  </Button>
                </div>
              </div>
            )}

            
            {!isNextClicked && showAdvanced && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Custom Properties</h6>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    wordWrap: "break-word",
                  }}
                >
                  {JSON.stringify(customProperties, null, 2)}
                </pre>
              </div>
            )}

            {isNextClicked && (
              <div className={classes.secondModalContent}>
                <h3>Meeting Rooms</h3>
                {loading ? (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={open}
                    onClick={handleClose}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                ) : (
                  <MeetingRoomTable
                    meetingRooms={meetingRooms}
                    orientationOptions={orientationOptions}
                    shortNavigationOptions={shortNavigationOptions}
                    handleOrientationChange={handleOrientationChange}
                    handleShortNavigationChange={handleShortNavigationChange}
                  />
                )}
              </div>
            )}
            

             <Box sx={{ 
              width: "100%",  
              marginTop: 2,
              display:isNextClicked?"flex":"unset",
              justifyContent:"end",
              gap:2
              }}>
              {!isNextClicked && !showAdvanced && (
                  <Box
                sx={{
                  display:"flex",
                  gap:2,
                  justifyContent:"end",
                  mt:2
                }}
                >
                  <Button
                    style={{ textTransform: "none" }}
                    variant="outlined"
                    color="error"
                    onClick={() => setOpen(false)}
                    disabled={isSubmitting}
                  >
                    Close
                  </Button>
                  <Button
                    style={{ textTransform: "none" }}
                    variant="outlined"
                    color="primary"
                    onClick={toggleAdvanced}
                  >
                    Advanced
                  </Button>
                {screenType === "Kiosk" ? (
                  <Button
                    style={{
                      textTransform: "none",
                    }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <CircularProgress size={24} /> : "Save"}
                  </Button>
                ) : (
                  <Button
                    style={{
                      textTransform: "none",
                    }}
                    onClick={handleNext}
                    variant="contained"
                    color="primary"
                  >
                    Next
                  </Button>
                )}
                </Box>
              )}
            
              {isNextClicked && (
                <Button
                  onClick={handleBack}
                  variant="outlined"
                  color="primary"
                >
                  Back
                </Button>
              )}
              {isNextClicked && (
                <Button
                  style={{
                    textTransform: "none",
                  }}
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              )}
            </Box>
            <Modal
              open={errorModalOpen}
              onClose={handleModalClose}
              className={classes.modal}
            >
              <div className={classes.paper}>
                <h2>{error === true ? "Oops" : "Congratulations"}</h2>
                <p>{errorMessage}</p>
                <Button
                  style={{ textTransform: "none", marginLeft: "75%" }}
                  onClick={handleModalClose}
                  variant="contained"
                  color="primary"
                >
                  Close
                </Button>
              </div>
            </Modal>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default MyScreenuserForm;
